import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useNavigationState } from "@/zustand/NavigationState";

export function useStartInvoicesView() {
  const startInvoicesView = useNavigationState((s) => s.startInvoicesView);
  const navigate = useNavigate();

  return useCallback(() => {
    startInvoicesView();
    navigate("/");
  }, [startInvoicesView, navigate]);
}
